export default __webpack_public_path__ + "e13c9a1.png";